import { render, staticRenderFns } from "./FitChartsNewEdit.vue?vue&type=template&id=01bd9ece"
import script from "./FitChartsNewEdit.vue?vue&type=script&lang=js"
export * from "./FitChartsNewEdit.vue?vue&type=script&lang=js"
import style0 from "./FitChartsNewEdit.vue?vue&type=style&index=0&id=01bd9ece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports